/**
 * @Author: v_jppjpeng
 * @Date: 2023-08-03 14:33:48
 * @Explain: Dialog - 函数式
 */
import { ReactNode } from 'react';
import { MessageInstance, MessageOptions, MessagePlugin } from 'tdesign-react';
import { MessageComponentProps } from 'tdesign-react/es/message/MessageComponent';
// utils
import { getSessionStorage } from '@/utils/global';
// type
import { StoreKeyEnum } from '@/definition/common/data.d';

interface MessageProps extends MessageComponentProps, MessageOptions {
  description?: string | ReactNode;
}

// 全局提示
class Message {
  getConfig(config: MessageProps) {
    const { description, duration = 3000, onClose } = config;
    return {
      content: description,
      duration,
      onClose,
      ...config,
    };
  }
  info(config: MessageProps) {
    return MessagePlugin.info(this.getConfig(config));
  }
  warning(config: MessageProps) {
    return MessagePlugin.warning(this.getConfig(config));
  }
  success(config: MessageProps) {
    MessagePlugin.closeAll(); // 防止重复出现多个
    return MessagePlugin.success(this.getConfig(config));
  }
  error(config: MessageProps) {
    // 其它途径跳转至系统携带业务ID - 报错提示信息避免出现多个
    if (getSessionStorage(StoreKeyEnum.GAME_ID)) MessagePlugin.closeAll();
    return MessagePlugin.error(this.getConfig(config));
  }
  // 关闭所有消息通知
  closeAll() {
    MessagePlugin.closeAll();
  }
  // 关闭指定消息通知
  close(message: Promise<MessageInstance>) {
    MessagePlugin.close(message);
  }
}

export default new Message();
